import http from ":http";

export function requestExchangeToken(mailAddress) {
  return http.get(`/users/${mailAddress}/exchange-token`);
}

export function requestToken(token) {
  return http.post("/users/authentication", { token });
}
